import { environment } from '../environments/environment';

export class AppConfig {
  public static getConfig(): any {
    return environment;
  }
}
